import { useTrans } from '@/shared/hooks/useTranslation';
import { Button } from '@/view/shared/Button';
import { ArrowLeft, Network } from 'lucide-react';
import type React from 'react';

interface WorkspaceSourceBarProps {
  readonly projectName: string;
  readonly isStore: boolean;
  readonly isHidden: boolean;
  readonly onBack: () => void;
  readonly onOpenAccess: () => void;
}

export function WorkspaceSourceBar({
  projectName,
  isStore,
  isHidden,
  onBack,
  onOpenAccess,
}: Readonly<WorkspaceSourceBarProps>): React.JSX.Element | null {
  const { t } = useTrans();

  if (isHidden) return null;

  return (
    <div className="shrink-0 w-full px-4 sm:px-6 md:px-8 lg:px-16 py-2 border-b border-border bg-surface">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-2 min-w-0">
          <Button variant="secondary" size="sm" onClick={onBack}>
            <ArrowLeft size={13} strokeWidth={1.75} />
            {t('dataConsole.scope.back')}
          </Button>
          <div className="min-w-0">
            <p className="text-sm font-medium text-foreground truncate">
              {isStore
                ? t('dataConsole.scope.store')
                : t('dataConsole.scope.project', { project: projectName })}
            </p>
            {isStore ? (
              <p className="text-caption text-muted-foreground truncate">
                {t('dataConsole.scope.storeHint')}
              </p>
            ) : null}
          </div>
        </div>
        {isStore ? (
          <Button variant="secondary" size="sm" onClick={onOpenAccess}>
            <Network size={13} strokeWidth={1.75} />
            {t('dataConsole.scope.openAccess')}
          </Button>
        ) : null}
      </div>
    </div>
  );
}
